import React, { useEffect, useState } from 'react';

const useBodyScrollLock = () => {
  const [isLocked, setIsLocked] = useState(false);
  useEffect(() => {
    document.body.style.overflow = isLocked ? 'hidden' : 'auto';
  }, [isLocked]);
  const lockScroll = () => !isLocked && setIsLocked(true);
  const unLockScroll = () => isLocked && setIsLocked(false);
  return {
    isLocked,
    lockScroll,
    unLockScroll,
  };
};

export default useBodyScrollLock;
